// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"736":"3fc5d99a","787":"dc7b5a83","850":"cb57e2e1"}[chunkId] + ".chunk.js";
};